import type { VAxios } from '../../define/axios/Axios';

/** /la/qa/stream 每条 SSE 事件的 data 字段结构 */
export type QaStreamEvent =
  | { type: 'start'; content: { session_id: number } }
  | { type: 'content'; content: string }
  | { type: 'done' | 'end'; content?: any };

export const createApi = (defHttp: VAxios) => ({
  // 获取一对一客服信息
  postLaEscalate(params: {
    session_id: number;
    trigger_keyword?: string;
    trigger_type?: string; // 'manual_click';
    user_id: string;
  }): Promise<{
    escalation_id: number;
    message: string;
    qr_code_url: string;
    status: string;
  }> {
    return defHttp.post({
      url: '/la/escalate',
      params: Object.assign(
        {
          trigger_keyword: '',
          trigger_type: 'manual_click',
        },
        params
      ),
    });
  },

  // 流式回答前检测当前问题类型
  postLaEscalateDetect(params: { message: string }): Promise<{
    needs_escalation: boolean; // true 表示需要人工客服，false 不用
    intent_type: string;
    confidence: number;
    reason: string;
    trigger_keyword: string | null;
  }> {
    return defHttp.post({
      url: '/la/escalate/detect',
      params,
    });
  },

  // 获取猜你想问
  getLaGuideQuestions(): Promise<{
    items: {
      enabled: boolean;
      sort_order: number;
      question: string;
    }[];
  }> {
    return defHttp.get({
      url: '/la/guide-questions/active',
    });
  },

  // 获取推荐问题
  getLaQuestionSuggestions(params: { q: string; limit?: number }): Promise<{
    items: {
      question_id: number;
      fragment_id: number;
      question: string;
      score: number;
      question_type: string;
      title: string;
      url: string | null;
    }[];
  }> {
    return defHttp.get({
      url: '/la/question-suggestions',
      params,
    });
  },

  // 消息反馈
  postLaMessagesFeedback(
    id: number,
    params: {
      feedback_type: number;
      negative_reason?: string;
      negative_comment?: string;
    }
  ): Promise<void> {
    return defHttp.post({
      url: `/la/messages/${id}/feedback`,
      params,
    });
  },

  // 提交满意度反馈
  postLaFeedbackSubmit(params: {
    session_id: number;
    feedback_type: number;
    reasons: string;
    comment?: string;
  }): Promise<void> {
    return defHttp.post({
      url: `/la/messages/${params.session_id}/feedback`,
      params,
    });
  },

  // 获取流式回答（SSE / EventStream）
  // 返回 AsyncGenerator，调用方用 for-await-of 逐事件消费
  // 传入 signal 可随时取消（new AbortController().signal）
  postLaQaStream(
    params: {
      question: string;
      source?: string;
      llm?: string;
      agentic?: boolean;
      image_urls?: string[];
    },
    signal?: AbortSignal
  ) {
    return defHttp.eventStream<QaStreamEvent>({
      url: '/la/qa/stream',
      method: 'POST',
      data: Object.assign(
        {
          agentic: true,
          image_urls: [],
          llm: 'qwen',
          source: 'king',
        },
        params
      ),
      signal,
    });
  },
});
